<template>
    <div v-if="isStatusLoading">
        <div class="text-center mb-3">{{ loadingText }}</div>
        <LoadingAnimation animation-style="bars"></LoadingAnimation>
    </div>

    <div v-else class="w-100 d-flex justify-content-evenly flex-wrap">
        <div  class="user-modal-choose-payment-view px-4">
            <p class="font-weight-bold font-size-175 mb-0">
                {{ titleText }}
            </p>

            <ChoosePayment
                v-if="stripePaymentIntent !== ''"
                :disabled="isSubmitting"
                :stripe-payment-intent="stripePaymentIntent"
                ref="choosePayment"
            ></ChoosePayment>

            <div class="d-flex justify-content-between">
                <strong v-for="text in dueText" v-html="text" class="font-size-125"></strong>
            </div>

            <ButtonWithLoadingState
                data-user-modal-button-submit
                class="btn btn-success btn-lg btn-block font-weight-bold font-size-125 rounded d-flex justify-content-center gap-10"
                icon="fa fa-arrow-right lh-1"
                :text="submitButtonText"
                :is-state-loading="isSubmitting"
                :disabled="!productSlug"
                :show-icon-after-text="true"
                @click.stop.prevent="doPayment"
            ></ButtonWithLoadingState>

            <div
                class="text-muted small"
                v-html="postSubmitButtonText"
                @click.stop.prevent="onBottomTextClicked"
            ></div>

            <div
                class="text-center small"
                v-html="payNowTextSale"
                @click.stop.prevent="onBottomTextClicked"
                v-if="isSale && this.selectedBilling === 'annual_%currency%_%version%_sale_cyberweek'"
            ></div>

            <button
                data-user-modal-input-provider-paypal
                :disabled="isSubmitting || !productSlug"
                @click.stop.prevent="payPalPayment"
                class="position-relative btn paypal-gold btn-lg btn-block font-weight-bold text-uppercase rounded"
            >
                <span
                    v-if="isSubmitting"
                    class="position-absolute d-flex top-0 left-0 h-100 w-100 align-items-center justify-content-center"
                >
                    <i class="fa fa-spin btn-loading-animation"></i>
                </span>

                <span class="">
                    <!--                {{ payPalButtonText }}-->
                    <svg height="28px" width="115px" viewBox="0 0 123.59 30.18" class="w-auto">
                        <g>
                            <path
                                fill="#253B80"
                                d="M46.211,6.749h-6.839c-0.468,0-0.866,0.34-0.939,0.802l-2.766,17.537c-0.055,0.346,0.213,0.658,0.564,0.658
                                h3.265c0.468,0,0.866-0.34,0.939-0.803l0.746-4.73c0.072-0.463,0.471-0.803,0.938-0.803h2.165c4.505,0,7.105-2.18,7.784-6.5
                                c0.306-1.89,0.013-3.375-0.872-4.415C50.224,7.353,48.5,6.749,46.211,6.749z M47,13.154c-0.374,2.454-2.249,2.454-4.062,2.454
                                h-1.032l0.724-4.583c0.043-0.277,0.283-0.481,0.563-0.481h0.473c1.235,0,2.4,0,3.002,0.704C47.027,11.668,47.137,12.292,47,13.154z"
                            />
                            <path
                                fill="#253B80"
                                d="M66.654,13.075h-3.275c-0.279,0-0.52,0.204-0.563,0.481l-0.145,0.916l-0.229-0.332
                                c-0.709-1.029-2.29-1.373-3.868-1.373c-3.619,0-6.71,2.741-7.312,6.586c-0.313,1.918,0.132,3.752,1.22,5.031
                                c0.998,1.176,2.426,1.666,4.125,1.666c2.916,0,4.533-1.875,4.533-1.875l-0.146,0.91c-0.055,0.348,0.213,0.66,0.562,0.66h2.95
                                c0.469,0,0.865-0.34,0.939-0.803l1.77-11.209C67.271,13.388,67.004,13.075,66.654,13.075z M62.089,19.449
                                c-0.316,1.871-1.801,3.127-3.695,3.127c-0.951,0-1.711-0.305-2.199-0.883c-0.484-0.574-0.668-1.391-0.514-2.301
                                c0.295-1.855,1.805-3.152,3.67-3.152c0.93,0,1.686,0.309,2.184,0.892C62.034,17.721,62.232,18.543,62.089,19.449z"
                            />
                            <path
                                fill="#253B80"
                                d="M84.096,13.075h-3.291c-0.314,0-0.609,0.156-0.787,0.417l-4.539,6.686l-1.924-6.425
                                c-0.121-0.402-0.492-0.678-0.912-0.678h-3.234c-0.393,0-0.666,0.384-0.541,0.754l3.625,10.638l-3.408,4.811
                                c-0.268,0.379,0.002,0.9,0.465,0.9h3.287c0.312,0,0.604-0.152,0.781-0.408L84.564,13.97C84.826,13.592,84.557,13.075,84.096,13.075z
                                "
                            />
                            <path
                                fill="#179BD7"
                                d="M94.992,6.749h-6.84c-0.467,0-0.865,0.34-0.938,0.802l-2.766,17.537c-0.055,0.346,0.213,0.658,0.562,0.658
                                h3.51c0.326,0,0.605-0.238,0.656-0.562l0.785-4.971c0.072-0.463,0.471-0.803,0.938-0.803h2.164c4.506,0,7.105-2.18,7.785-6.5
                                c0.307-1.89,0.012-3.375-0.873-4.415C99.004,7.353,97.281,6.749,94.992,6.749z M95.781,13.154c-0.373,2.454-2.248,2.454-4.062,2.454
                                h-1.031l0.725-4.583c0.043-0.277,0.281-0.481,0.562-0.481h0.473c1.234,0,2.4,0,3.002,0.704
                                C95.809,11.668,95.918,12.292,95.781,13.154z"
                            />
                            <path
                                fill="#179BD7"
                                d="M115.434,13.075h-3.273c-0.281,0-0.52,0.204-0.562,0.481l-0.145,0.916l-0.23-0.332
                                c-0.709-1.029-2.289-1.373-3.867-1.373c-3.619,0-6.709,2.741-7.311,6.586c-0.312,1.918,0.131,3.752,1.219,5.031
                                c1,1.176,2.426,1.666,4.125,1.666c2.916,0,4.533-1.875,4.533-1.875l-0.146,0.91c-0.055,0.348,0.213,0.66,0.564,0.66h2.949
                                c0.467,0,0.865-0.34,0.938-0.803l1.771-11.209C116.053,13.388,115.785,13.075,115.434,13.075z M110.869,19.449
                                c-0.314,1.871-1.801,3.127-3.695,3.127c-0.949,0-1.711-0.305-2.199-0.883c-0.484-0.574-0.666-1.391-0.514-2.301
                                c0.297-1.855,1.805-3.152,3.67-3.152c0.93,0,1.686,0.309,2.184,0.892C110.816,17.721,111.014,18.543,110.869,19.449z"
                            />
                            <path
                                fill="#179BD7"
                                d="M119.295,7.23l-2.807,17.858c-0.055,0.346,0.213,0.658,0.562,0.658h2.822c0.469,0,0.867-0.34,0.939-0.803
                                l2.768-17.536c0.055-0.346-0.213-0.659-0.562-0.659h-3.16C119.578,6.749,119.338,6.953,119.295,7.23z"
                            />
                            <path
                                fill="#253B80"
                                d="M7.266,29.154l0.523-3.322l-1.165-0.027H1.061L4.927,1.292C4.939,1.218,4.978,1.149,5.035,1.1
                                c0.057-0.049,0.13-0.076,0.206-0.076h9.38c3.114,0,5.263,0.648,6.385,1.927c0.526,0.6,0.861,1.227,1.023,1.917
                                c0.17,0.724,0.173,1.589,0.007,2.644l-0.012,0.077v0.676l0.526,0.298c0.443,0.235,0.795,0.504,1.065,0.812
                                c0.45,0.513,0.741,1.165,0.864,1.938c0.127,0.795,0.085,1.741-0.123,2.812c-0.24,1.232-0.628,2.305-1.152,3.183
                                c-0.482,0.809-1.096,1.48-1.825,2c-0.696,0.494-1.523,0.869-2.458,1.109c-0.906,0.236-1.939,0.355-3.072,0.355h-0.73
                                c-0.522,0-1.029,0.188-1.427,0.525c-0.399,0.344-0.663,0.814-0.744,1.328l-0.055,0.299l-0.924,5.855l-0.042,0.215
                                c-0.011,0.068-0.03,0.102-0.058,0.125c-0.025,0.021-0.061,0.035-0.096,0.035H7.266z"
                            />
                            <path
                                fill="#179BD7"
                                d="M23.048,7.667L23.048,7.667L23.048,7.667c-0.028,0.179-0.06,0.362-0.096,0.55
                                c-1.237,6.351-5.469,8.545-10.874,8.545H9.326c-0.661,0-1.218,0.48-1.321,1.132l0,0l0,0L6.596,26.83l-0.399,2.533
                                c-0.067,0.428,0.263,0.814,0.695,0.814h4.881c0.578,0,1.069-0.42,1.16-0.99l0.048-0.248l0.919-5.832l0.059-0.32
                                c0.09-0.572,0.582-0.992,1.16-0.992h0.73c4.729,0,8.431-1.92,9.513-7.476c0.452-2.321,0.218-4.259-0.978-5.622
                                C24.022,8.286,23.573,7.945,23.048,7.667z"
                            />
                            <path
                                fill="#222D65"
                                d="M21.754,7.151c-0.189-0.055-0.384-0.105-0.584-0.15c-0.201-0.044-0.407-0.083-0.619-0.117
                                c-0.742-0.12-1.555-0.177-2.426-0.177h-7.352c-0.181,0-0.353,0.041-0.507,0.115C9.927,6.985,9.675,7.306,9.614,7.699L8.05,17.605
                                l-0.045,0.289c0.103-0.652,0.66-1.132,1.321-1.132h2.752c5.405,0,9.637-2.195,10.874-8.545c0.037-0.188,0.068-0.371,0.096-0.55
                                c-0.313-0.166-0.652-0.308-1.017-0.429C21.941,7.208,21.848,7.179,21.754,7.151z"
                            />
                            <path
                                fill="#253B80"
                                d="M9.614,7.699c0.061-0.393,0.313-0.714,0.652-0.876c0.155-0.074,0.326-0.115,0.507-0.115h7.352
                                c0.871,0,1.684,0.057,2.426,0.177c0.212,0.034,0.418,0.073,0.619,0.117c0.2,0.045,0.395,0.095,0.584,0.15
                                c0.094,0.028,0.187,0.057,0.278,0.086c0.365,0.121,0.704,0.264,1.017,0.429c0.368-2.347-0.003-3.945-1.272-5.392
                                C20.378,0.682,17.853,0,14.622,0h-9.38c-0.66,0-1.223,0.48-1.325,1.133L0.01,25.898c-0.077,0.49,0.301,0.932,0.795,0.932h5.791
                                l1.454-9.225L9.614,7.699z"
                            />
                        </g>
                    </svg>
                </span>
            </button>

            <div id="smart-button-container">
                <div style="text-align: center">
                    <div id="paypal-button-container"></div>
                </div>
            </div>

            <div class="w-100 position-relative">
                <Transition name="fade-grow-slow">
                    <div
                        class="border bg-white rounded position-absolute w-100 bottom-0 shadow"
                        v-if="showRefundInfo"
                        style="max-width: 404px; z-index: 100; left: 50%; transform: translate(-50%, 0)"
                    >
                        <div class="transition-header">
                            <p class="font-size-125 font-weight-bold position-relative m-0">
                                {{ 'Refund policy' | trans }}
                            </p>
                            <span
                                data-user-modal-payment-refund-info-close
                                @click.stop.prevent="showRefundInfo = false"
                                class="cursor-pointer font-size-150"
                            >&times;</span>
                        </div>
                        <div style="padding: 1rem;">
                            <p>{{ 'You can request a full refund within 14 days after you subscribed with no questions asked. Please contact our support team for assistance.' | trans }}</p>
                            <p class="mb-0">{{ 'Please note that you are not eligible for a refund anymore after 14 days.' | trans }}</p>
                        </div>
                    </div>
                </Transition>

                <Transition name="fade-grow-slow">
                    <div
                        class="border bg-white rounded position-absolute w-100 bottom-0 shadow"
                        v-if="showCancelInfo"
                        style="max-width: 404px; z-index: 100; left: 50%; transform: translate(-50%, 0)"
                    >
                        <div class="transition-header">
                            <p class="font-size-125 font-weight-bold position-relative m-0">
                                {{ 'Cancel the subscription at any time' | trans }}
                            </p>
                            <span
                                data-user-modal-payment-cancel-info-close
                                @click.stop.prevent="showCancelInfo = false"
                                class="cursor-pointer font-size-150"
                            >&times;</span>
                        </div>
                    <div style="padding: 1rem;">
                            <p>{{ 'In order to cancel your subscription, please login and go to your dashboard.' | trans }}</p>
                            <p class="mb-0">{{ 'You will be able to use the service after cancellation for the amount of time you have already paid for. You can reactivate your subscription later at any time.' | trans }}</p>

                        </div>
                    </div>
                </Transition>
            </div>

            <div v-if="showBackButton" class="d-flex justify-content-center">
                <ButtonWithLoadingState
                    class="position-relative btn font-weight-bold font-size-125 text-uppercase rounded"
                    icon="fa fa-arrow-left lh-1"
                    :text="backButtonText"
                    :is-state-loading="isSubmitting"
                    :disabled="!productSlug"
                    :show-icon-after-text="false"
                    @click.stop.prevent="goBack"
                ></ButtonWithLoadingState>
            </div>

            <Transition name="fade-fast">
                <div
                    v-if="showCancelInfo || showRefundInfo"
                    @click.stop.prevent="
                        showRefundInfo = false;
                        showCancelInfo = false;
                    "
                    class="position-absolute w-100 h-100 top-0 left-0 bg-modal"
                    style="z-index: 99; box-shadow: 0 0 2000px 2000px rgb(0 0 0 / 50%)"
                ></div>
            </Transition>
            <!-- min-height 45px to prevent bouncing around on oc when switching between daily pass and subscriptions -->
        </div>

        <YourPlan></YourPlan>
    </div>
</template>

<script>
import ButtonWithLoadingState from '../../../../../qaamgo/modules/sat/components/form/ButtonWithLoadingState';
import TransFilter from '../../../../../qaamgo/modules/sat/components/mixins/TransFilter';
import { userModalRoute } from '../router';
import { translate } from '../../../../../qaamgo/helper/translate';
import ChoosePayment from '../components/ChoosePayment';
import YourPlan from '../components/YourPlan';
import { paymentManager } from '../../../../payment/payment-manager';
import { projectHelper } from '../../../../misc/project-helper';
import { pageStoreMixin } from '../../../../store/page-store';
import { testIsNonEmptyString, testIsTrueish } from '../../../../../lib/test-and-assert/test-base';
import { getLocalizedDateString } from '../../../../../lib/localization/date-helper';
import { satGlobals } from '../../../../../qaamgo/sat/helper/sat-globals';
import { globalLogger } from '../../../../../qaamgo/helper/global-logger';
import { pageNotification } from '../../../../../qaamgo/helper/notify';
import DataStatus from '../../../../../qaamgo/modules/sat/components/mixins/DataStatus';
import LoadingAnimation from '../../../../../qaamgo/modules/sat/components/LoadingAnimation';

export default {
    name: 'RegisterChoosePaymentView',
    components: {
        LoadingAnimation,
        ChoosePayment,
        ButtonWithLoadingState,
        YourPlan,
    },
    mixins: [TransFilter, DataStatus, pageStoreMixin],
    created() {
        this.initializeData();
    },
    watch: {
        selectedBilling(oldVal, newVal) {
            if (oldVal && newVal && oldVal !== newVal) {
                this.setStatusLoading();
                this.initializeData();
            }
        }
    },
    computed: {
        /** @return {User} */
        storeUser() {
            return this.store.user.getUser;
        },
        isSale() {
            return this.store.userPaymentModal.isSale;
        },
        selectedPlan() {
            return this.store.userPaymentModal.selectedPlan;
        },
        selectedSize() {
            return this.store.userPaymentModal.selectedSize;
        },
        selectedProvider() {
            return this.store.userPaymentModal.selectedProvider;
        },
        selectedProduct() {
            return this.store.userPaymentModal.selectedProduct;
        },
        selectedQuota() {
            return this.store.userPaymentModal.selectedQuota;
        },
        selectedBilling() {
            return this.store.userPaymentModal.selectedBilling;
        },
        /** @return {Boolean} */
        isSubmitting() {
            return this.store.userPaymentModal.isSubmitting;
        },
        currency() {
            return this.store.userPaymentModal.currency;
        },
        productSlug() {
            if (!satGlobals.isCreditsInAllSatsEnabled() && projectHelper.isOnlineConvert() && this.selectedBilling === 'day') {
                const sizeInt = Number.parseInt(this.selectedSize);

                if (sizeInt < 1000) {
                    // ignore invalid in-between state - state should be fixed in next frame
                    return '';
                }
            }

            /** @type {PaymentData} */
            const paymentData = {};

            paymentData.billing = this.selectedBilling;
            paymentData.provider = this.selectedProvider;

            if (this.isCreditModal) {
                paymentData.credits = this.selectedSize;
            } else {
                if (satGlobals.isMultipleProductsEnabled()) {
                paymentData.product = this.store.userPaymentModal.selectedProduct;
                } else {
                paymentData.product = this.selectedSize;
                }
            }
            if (satGlobals.isCreditsInAllSatsEnabled()) {
                paymentData.product = this.selectedProduct;
                paymentData.quota = this.selectedQuota;
            }

            return paymentManager.getSlugHelper().getSlug(paymentData, this.currency);
        },
        productPriceString() {
            if (!this.productSlug) {
                return '-';
            }

            return paymentManager.getSlugHelper().getPriceStringFromSlug(this.productSlug);
        },
        priceStringDaily() {
            if (!this.isOc) {
                return '';
            }

            /** @type {PaymentData} */
            const paymentData = {};

            let selectedSize = this.selectedSize;
            if (this.isOc && Number.parseInt(this.selectedSize) < 1000) {
                selectedSize = '1000';
            }

            paymentData.billing = 'day';
            paymentData.product = selectedSize;
            paymentData.provider = this.selectedProvider;

            return paymentManager.getSlugHelper().getPriceString(paymentData, this.currency);
        },
        priceStringMonthly() {
            if (this.isApi2Convert) {
                return '';
            }

            /** @type {PaymentData} */
            const paymentData = {};

            paymentData.billing = 'month';
            paymentData.product = this.selectedSize;
            paymentData.provider = this.selectedProvider;

            return paymentManager.getSlugHelper().getPriceString(paymentData, this.currency);
        },
        priceStringYearly() {
            if (this.isApi2Convert) {
                return '';
            }

            /** @type {PaymentData} */
            const paymentData = {};

            paymentData.billing = 'annual';
            paymentData.product = this.selectedSize;
            paymentData.provider = this.selectedProvider;

            return paymentManager.getSlugHelper().getPriceString(paymentData, this.currency);
        },
        monthlyPriceForAnnual() {
            if (this.isApi2Convert) {
                return '';
            }

            /** @type {PaymentData} */
            const paymentData = {};

            paymentData.billing = 'annual';
            paymentData.product = this.selectedSize;
            paymentData.provider = this.selectedProvider;

            return paymentManager.getSlugHelper().getMonthlyPriceForAnnual(paymentData, this.currency);
        },
        amountSavedForAnnual() {
            if (this.isApi2Convert) {
                return '';
            }

            /** @type {PaymentData} */
            const paymentData = {};

            paymentData.billing = 'annual';
            paymentData.product = this.selectedSize;
            paymentData.provider = this.selectedProvider;

            return paymentManager.getSlugHelper().getYearlyAmountSavedForAnnual(paymentData, this.currency);
        },
        yearlyPriceForMonthly() {
            if (this.isApi2Convert) {
                return '';
            }

            /** @type {PaymentData} */
            const paymentData = {};

            paymentData.billing = 'month';
            paymentData.product = this.selectedSize;
            paymentData.provider = this.selectedProvider;

            return paymentManager.getSlugHelper().getYearlyPriceForMonthly(paymentData, this.currency);
        },
        titleText() {
            return translate('Choose payment method');
        },
        getOrText() {
            return translate('Or');
        },
        loadingText() {
            return translate('Please wait while we are arranging bits and bytes.');
        },
        submitButtonText() {
            if (this.isTrialEnabled) {
                return translate('Try %count% days free', { '%count%': this.trialData.countDaysFreeTrialDuration });
            }

            return translate('Pay now');
        },
        isCreditModal() {
            return satGlobals.isCreditsEnabled() && this.storeUser.isPremium();
        },
        payPalButtonText() {
            return translate('Pay with');
        },
        backButtonText() {
            return translate('Back');
        },
        showBackButton() {
            return !satGlobals.isCreditsInAllSatsEnabled();
        },
        dueText() {
            if (this.isTrialEnabled) {
                return [
                    translate('Total due in free trial: <strong>%amount%</strong>', {
                        '%amount%': this.trialData.priceAtTrialStart[this.currency],
                    }),
                ];
            }

            if (this.isSale && this.selectedBilling === 'annual_%currency%_%version%_sale_cyberweek') {
                return [
                    translate('Total due: <strong>%salePrice%</strong> for the first year', {
                        '%salePrice%': this.productPriceString,
                    }),
                    translate('After that you will pay <strong>%amount%</strong> per year', {
                        '%amount%': this.getPriceStringForBillingAndProduct('annual'),
                    }),
                ];
            }

            return [
                translate('Total due:', {}),
                translate('<strong>%amount%</strong>', { '%amount%': this.productPriceString })
            ];
        },
        postSubmitButtonText() {
            let translated = this.getTranslatedSubmitButtonText();

            if (!testIsNonEmptyString(translated)) {
                globalLogger.log(
                    'user modal - invalid state - choose payment - postSubmitButtonText',
                    JSON.stringify({
                        isApi2Convert: this.isApi2Convert,
                        selectedBilling: this.selectedBilling,
                        isTrialEnabled: this.isTrialEnabled,
                    })
                );
            }

            return translated
                .replace(
                    /<a\s+id=\\?"refundLink\\?"\s*>(.+)<\/a>/,
                    '<a data-user-modal-link-payment-refund id="refundLink">$1</a>'
                )
                .replace(
                    /<a\s+id=\\?"cancelLink\\?"\s*>(.+)<\/a>/,
                    '<a data-user-modal-link-payment-cancel id="cancelLink">$1</a>'
                );
        },
        payNowTextSale() {
            return translate(
                `By clicking on “Pay now”, your payment method will get charged with an amount of %AMOUNT% for the first year. After that you will pay %AMOUNT_REGULAR% per year. You can <a id="cancelLink">cancel the payment</a> at any time. <a id=\"refundLink\">Refunds</a> can be requested within 14 days, no questions asked.`,
                { '%AMOUNT%': this.productPriceString, '%AMOUNT_REGULAR%': this.priceStringYearly }
            );
        },
    },
    methods: {
        initializeData() {
            if (!testIsNonEmptyString(this.selectedProvider)) {
                this.store.userPaymentModal.setSelectedProvider('stripe');
            }

            if (this.isApi2Convert) {
                if (!testIsNonEmptyString(this.selectedSize)) {
                    this.store.userPaymentModal.setSelectedSize('500');
                }

                if (!testIsNonEmptyString(this.selectedBilling)) {
                    this.store.userPaymentModal.setSelectedBilling('day');
                }

                this.createPaymentIntent()
                    .then(() => {
                        this.setStatusDone();
                        this.store.userPaymentModal.setSubmitting(false);
                    })
                    .catch((/** AxiosError */ error) => {
                        pageNotification.showGenericErrorMessage();

                        globalLogger.log('user modal - paymentIntent - stripe - fail', error);

                        this.goBack();
                    });

                return;
            }

            if (!satGlobals.isCreditsInAllSatsEnabled() && this.isOc && !testIsNonEmptyString(this.selectedSize)) {
                this.store.userPaymentModal.setSelectedSize('200');
            }

            if (!testIsNonEmptyString(this.selectedBilling)) {
                this.store.userPaymentModal.setSelectedBilling('annual');
            }

            this.trialData = paymentManager.getTrialData();

            this.trialData.countDaysFreeTrialDuration = satGlobals.getFreeTrialPeriod();

            const firstChargeDateObject = new Date();
            firstChargeDateObject.setDate(firstChargeDateObject.getDate() + this.trialData.countDaysFreeTrialDuration);

            const isFromEurope = testIsTrueish(this.storeUser?.getExtraKey('europe'));

            this.trialData.dateFirstChargeShort = getLocalizedDateString(
                satGlobals.getLocale(),
                firstChargeDateObject,
                { month: 'long', day: 'numeric' },
                isFromEurope
            );

            this.trialData.dateFirstChargeFull = getLocalizedDateString(
                satGlobals.getLocale(),
                firstChargeDateObject,
                { year: 'numeric', month: 'long', day: 'numeric' },
                isFromEurope
            );

            this.largestPurchasableFileSize = paymentManager.getLargestPurchasableFileSize();

            this.createPaymentIntent()
                .then(() => {
                    this.setStatusDone();
                    this.store.userPaymentModal.setSubmitting(false);
                })
                .catch((/** AxiosError */ error) => {
                    if (error?.data?.message === 'user_has_already_same_product') {
                        globalLogger.log('user modal - paymentIntent - stripe - user_already_has_same_product', error);
                        pageNotification.error('You already have purchased this product. Please select another one.');

                        this.goBack();

                        return;
                    }

                    pageNotification.showGenericErrorMessage();

                    globalLogger.log('user modal - paymentIntent - stripe - fail', error);

                    this.goBack();
                });
        },
        getTranslatedSubmitButtonText() {
            if (this.isApi2Convert || this.selectedBilling === 'day' || this.selectedBilling === 'week') {
                return translate(
                    `By clicking on “Pay now”, your payment method will get charged with an amount of %AMOUNT%. <a id=\"refundLink\">Refunds</a> can be requested within 14 days, no questions asked.`,
                    { '%AMOUNT%': this.productPriceString }
                );
            }

            if (this.isTrialEnabled && this.selectedBilling === 'annual') {
                return translate(
                    `By clicking on “Try %trialDays% days free”, you agree that we will automatically continue your subscription after the end of the free trial (%date%) and then your payment method will get charged with a recurring annual amount of %amount%. You can <a id=\"cancelLink\">cancel the payment</a> at any time.`,
                    {
                        '%trialDays%': this.trialData.countDaysFreeTrialDuration,
                        '%date%': this.trialData.dateFirstChargeFull,
                        '%amount%': this.productPriceString,
                    }
                );
            }

            if (this.isTrialEnabled && this.selectedBilling === 'month') {
                return translate(
                    `By clicking on “Try %trialDays% days free”, you agree that we will automatically continue your subscription after the end of the free trial (%date%) and then your payment method will get charged with a recurring monthly amount of %amount%. You can <a id=\"cancelLink\">cancel the payment</a> at any time.`,
                    {
                        '%trialDays%': this.trialData.countDaysFreeTrialDuration,
                        '%date%': this.trialData.dateFirstChargeFull,
                        '%amount%': this.productPriceString,
                    }
                );
            }

            if (satGlobals.isCreditsInAllSatsEnabled()) {
                if (this.selectedProduct === 'payg') {
                    return translate(
                               'By clicking on “Pay now”, your payment method will get charged with an amount of %AMOUNT%. <a id=\"refundLink\">Refunds</a> can be requested within 14 days, no questions asked.',
                        { '%AMOUNT%': this.productPriceString }
                    );
                }
            }

            if (this.selectedBilling === 'annual') {
                return translate(
                    `By clicking on “Pay now”, your payment method will get charged with a recurring annual amount of %amount%. You can <a id=\"cancelLink\">cancel the payment</a> at any time. <a id=\"refundLink\">Refunds</a> can be requested within 14 days, no questions asked.`,
                    { '%amount%': this.productPriceString }
                );
            }

            if (this.selectedBilling === 'month') {
                return translate(
                    `By clicking on “Pay now”, your payment method will get charged with a recurring monthly amount of %amount%. You can <a id=\"cancelLink\">cancel the payment</a> at any time. <a id=\"refundLink\">Refunds</a> can be requested within 14 days, no questions asked.`,
                    { '%amount%': this.productPriceString }
                );
            }

            return '';
        },
        onBottomTextClicked(event) {
            const isRefundLinkClicked = event?.target?.id === 'refundLink';
            const isCancelLinkClicked = event?.target?.id === 'cancelLink';
            if (!isRefundLinkClicked && !isCancelLinkClicked) {
                return;
            }

            if (isRefundLinkClicked) {
                this.showRefundInfo = !this.showRefundInfo;

                if (this.showRefundInfo) {
                    this.showCancelInfo = false;
                }

                return;
            }

            if (isCancelLinkClicked) {
                this.showCancelInfo = !this.showCancelInfo;

                if (this.showCancelInfo) {
                    this.showRefundInfo = false;
                }
            }
        },
        getFormattedConversionMinutes(minutes) {
            const addedDot = minutes.replace(/(0{3}){0,1}(0{3}){1,}$/, '.$1.$2');

            // remove double dot
            return addedDot.replace(/\.+/, '.');
        },
        goBack() {
            this.$router.back();
        },
        async createPaymentIntent() {
            if (this.selectedBilling === 'day' || this.selectedBilling === 'week' || this.selectedProduct === 'payg') {
                return paymentManager.createStripeOrderPaymentIntent(this.productSlug, this.storeUser.getId()).then((result) => {
                    this.stripePaymentIntent = result;
                });
            } else {
                return paymentManager.createStripeSubscriptionPaymentIntent(this.productSlug, this.storeUser.getId()).then((result) => {
                    this.stripePaymentIntent = result;
                });
            }
        },
        doPayment() {
            // user modal - payment attempt - stripe - start
            // user modal - payment attempt - paypal - start
            globalLogger.log('user modal - payment attempt - ' + this.selectedProvider + ' - start');

            this.store.userPaymentModal.setSubmitting(true);

            const slugHelper = paymentManager.getSlugHelper();

            let slug = this.productSlug;

            if (this.isTrialEnabled) {
                slug = slugHelper.getFreeTrialSlug(slug);
            }

            const isSubscription = slugHelper.isSubscriptionSlug(slug);

            if (this.selectedProvider === 'stripe') {
                this.handleStripe(isSubscription)
                    .then((result) => {
                        // probably never reached
                        globalLogger.log('user modal - payment attempt - stripe - success');

                        this.$router.push({
                            name: userModalRoute.REGISTER_PAYMENT_SUCCESS,
                            params: {
                                isTrial: this.isTrialEnabled,
                                countDaysReminderBeforeTrialEnd: this.trialData?.countDaysReminderBeforeTrialEnd ?? 0,
                                boughtSubscription: isSubscription,
                            },
                        });
                    })
                    .catch((error) => {
                        // probably never reached
                        this.store.userPaymentModal.setSubmitting(false);

                        const showCardErrorForTypes = ['validation_error', 'card_error'];
                        const showCardErrorForCodes = [
                            'payment_intent_authentication_failure',
                            'setup_intent_authentication_failure',
                        ];
                        const showProductErrors = ['user_has_already_same_product'];

                        let showCardError =
                            showCardErrorForTypes.includes(error?.type) || showCardErrorForCodes.includes(error?.code);

                        if (showCardError && testIsNonEmptyString(error?.message)) {
                            this.$refs.choosePayment.setCreditCardError(error.message);

                            globalLogger.log('user modal - payment attempt - stripe - card_error fail', error);

                            return;
                        }

                        if (showProductErrors.includes(error?.data?.message)) {
                            globalLogger.log(
                                'user modal - payment attempt - stripe - user_already_has_same_product',
                                error
                            );
                            pageNotification.error(
                                'You already have purchased this product. Please select another one.'
                            );

                            return;
                        }

                        pageNotification.showGenericErrorMessage();

                        globalLogger.log('user modal - payment attempt - stripe - fail', error);
                    });

                return;
            } else if (this.selectedProvider === 'paypal') {
                this.handlePaypal(slug, isSubscription)
                    .then((paypalRedirectLink) => {
                        globalLogger.log('user modal - payment attempt - paypal - redirect - start');

                        // full redirect to paypal to start payment flow
                        window.allowLeave = true;
                        window.location = paypalRedirectLink;

                        return;
                    })
                    .catch((error) => {
                        const showProductErrors = ['user_has_already_same_product'];

                        if (showProductErrors.includes(error?.data?.message)) {
                            globalLogger.log(
                                'user modal - payment attempt - paypal - user_already_has_same_product',
                                error
                            );
                            pageNotification.error(
                                'You already have purchased this product. Please select another one.'
                            );

                            this.store.userPaymentModal.setSubmitting(false);

                            return;
                        }

                        pageNotification.showGenericErrorMessage();
                        this.store.userPaymentModal.setSubmitting(false);

                        globalLogger.log('user modal - payment attempt - paypal - fail', error);
                    });

                return;
            }

            pageNotification.showGenericErrorMessage();

            this.store.userPaymentModal.setSubmitting(false);

            globalLogger.log(
                'user modal - invalid state - choose payment - doPayment',
                JSON.stringify({
                    selectedProvider: this.selectedProvider,
                })
            );
        },
        payPalPayment() {
            this.store.userPaymentModal.setSelectedProvider('paypal');
            this.doPayment();
        },
        handleStripe(isSubscription) {
            return this.$refs.choosePayment.confirmStripePayment(isSubscription);
        },
        handlePaypal(slug, isSubscription) {
            if (isSubscription) {
                return paymentManager.handlePaymentPaypalSubscription(slug, this.storeUser.getId());
            }

            return paymentManager.handlePaymentPaypalOneTimePurchase(slug, this.storeUser.getId());
        },
        getPriceStringForBillingAndProduct(billing, product) {
            /** @type {PaymentData} */
            const paymentData = {};

            paymentData.billing = billing;
            paymentData.product = product ?? this.selectedSize;
            paymentData.provider = this.selectedProvider;

            return paymentManager.getSlugHelper().getPriceString(paymentData, this.currency);
        },
    },
    data() {
        return {
            userModalRoute: userModalRoute,
            showRefundInfo: false,
            showCancelInfo: false,
            stripePaymentIntent: '',
            trialData: {},
            isOc: projectHelper.isOnlineConvert(),
            isApi2Convert: projectHelper.isApi2Convert(),
            largestPurchasableFileSize: '',
            showWeekPass: satGlobals.isWeekPassEnabled(),
        };
    },
};
</script>

<style lang="scss">
@import '../../../../../../../../../../../node_modules/sass-material-colors/sass/sass-material-colors';

@import '../../../../../../scss/abstracts/mixins';
@import '../../../../../../scss/abstracts/functions';
@import '../../../../../../scss/abstracts/variables';
@import '../../../../../../../../../../../assets/scss/abstracts/variables';

@import '../../../../../../../../../../../node_modules/bootstrap/scss/functions';
@import '../../../../../../../../../../../node_modules/bootstrap/scss/variables';
@import '../../../../../../../../../../../node_modules/bootstrap/scss/mixins';

.user-modal-choose-payment-view {
    max-width: 510px;
    display: flex;
    flex-direction: column;
    gap: 20px;
}

.transition-header {
    display: flex;
    -ms-flex-align: start;
    align-items: center;
    -ms-flex-pack: justify;
    justify-content: space-between;
    padding: 1rem;
    border-bottom: 1px solid #dee2e6;
}

#cancelLink,
#refundLink {
    color: $link-color;
    cursor: pointer;
    text-decoration: underline;

    &:hover {
        color: $link-hover-color;
        text-decoration: none;
    }
}

.hr-text {
    line-height: 1em;
    position: relative;
    outline: 0;
    border: 0;
    color: #2e2e2e;
    text-align: center;
    height: 1.5em;
    opacity: 0.5;
    &:before {
        content: '';
        // use the linear-gradient for the fading effect
        // use a solid background color for a solid bar
        background: #6c757d;
        position: absolute;
        left: 0;
        top: 50%;
        width: 100%;
        height: 1px;
    }
    &:after {
        content: attr(data-content);
        position: relative;
        display: inline-block;
        color: black;

        padding: 0 0.5em;
        line-height: 1.5em;
        // this is really the only tricky part, you need to specify the background color of the container element...
        color: #2e2e2e;
        background-color: #f5f5f5;
    }
}
.paypal-gold {
    background-color: #ffc439;

    &:hover {
        filter: brightness(0.95);
    }
}
</style>
